<template>
  <div id="registerPage">
    <form v-if="showRegisterSuccessMessage" novalidate>
      <p class="has-text-centered is-size-7 disclaimer">Please enter the One Time Pin we sent to your mobile</p>
      <p class="control">
        <input v-model.trim="otp_form.otp" :disabled="sending" class="input hp-input" name="otp"
               placeholder="One Time Pin"
               type="text"/>
      </p>
      <p v-if="otp_form.errors.has('otp')" class="help is-danger" v-html="otp_form.errors.get('otp')"></p>
      <p class="control">
        <button
          id="otp_button"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="!canSubmitOtp || sending"
          type="submit"
          @click.prevent="submitOTP">VERIFY OTP
        </button>
      </p>
      <div v-html="OTP_MESSAGES.CHECK_SPAM.HTML"></div>
      <p class="control has-text-centered has-text-weight-bold is-size-7 lh">
        Having trouble verifying your account?<br/>
        WhatsApp&nbsp;<a class="link--v2 has-text-weight-bold" target="_blank" rel="nofollow" href="https://wa.me/27212066516">021&nbsp;206&nbsp;6516</a> to write your review
      </p>
      <!-- reCAPTCHA -->
      <div class="columns">
        <div class="column is-marginless captchaBox">
          <div class="has-text-right-desktop has-text-right-tablet">
            <vue-recaptcha
              ref="recaptcha_otp"
              :sitekey="`${google_recaptcha_site_key}`"
              size="invisible"
              @expired="onCaptchaExpiredOtp"
              @verify="onCaptchaVerifiedOtp">
            </vue-recaptcha>
          </div>
        </div>
      </div>
    </form>
    <!-- <p v-if="showRegisterSuccessMessage" class="register-success-message-box" v-html="registerSuccessMessage"></p> -->
    <form v-else novalidate>
      <p v-if="!require_email" class="control">
        <button class="button is-fullwidth hp-btn-primary social-button fb-button" @click.prevent="socialLogin('facebook', 'FB')"><i
          class="fab fa-facebook-f"></i>&nbsp;REGISTER WITH FACEBOOK
        </button>
      </p>
      <p v-if="!require_email" class="has-text-centered is-size-7 disclaimer">Don’t worry, we won’t post
        anything without your permission.</p>
      <p v-if="!require_email" class="control divider line one-line has-text-weight-bold">OR</p>
      <flash-message size="is-size-7"></flash-message>
      <p v-if="!require_email" class="control">
        <input v-model.trim="form.first_name" :disabled="sending" class="input hp-input" name="first_name"
               placeholder="First name"
               type="text"/>
      </p>
      <p v-if="form.errors.has('first_name')" class="help is-danger"
         v-html="form.errors.get('first_name')"></p>
      <p v-if="!require_email" class="control">
        <input v-model.trim="form.last_name" :disabled="sending" class="input hp-input" name="last_name"
               placeholder="Last name"
               type="text"/>
      </p>
      <p v-if="form.errors.has('last_name')" class="help is-danger" v-html="form.errors.get('last_name')"></p>
      <p v-if="require_email" class="social-email-require has-text-centered">We require an email address and mobile number for your account.</p>
      <p class="control">
        <input v-model.trim="form.email" :disabled="sending" class="input hp-input" name="email"
               placeholder="Email address"
               type="email"/>
      </p>
      <p v-if="form.errors.has('email')" class="help is-danger" v-html="form.errors.get('email')"></p>
      <p class="control">
        <vue-phone :phone.sync="form.mobile"/>
      </p>
      <p v-if="form.errors.has('mobile')" class="help is-danger" v-html="form.errors.get('mobile')"></p>
      <p v-if="!require_email" class="control has-icons-right password-input">
        <vue-password v-model.trim="form.password" :disableStrength="disableStrength" :disabled="sending"
                      classes="input hp-input" placeholder="Password"></vue-password>
      </p>
      <p v-if="form.errors.has('password')" class="help is-danger" v-html="form.errors.get('password')"></p>
      <p v-if="!require_email" class="control has-icons-right password-input">
        <vue-password v-model.trim="form.password_confirm" :disableStrength="disableStrength"
                      :disabled="sending"
                      classes="input hp-input" placeholder="Confirm password"></vue-password>
      </p>
      <p v-if="showPasswordNoMatch" class="help is-danger">The passwords do not match</p>
      <p v-if="form.errors.has('password_confirm')" class="help is-danger"
         v-html="form.errors.get('password_confirm')"></p>

      <!-- links for general terms and privacy policy -->
      <p class="has-text-centered is-size-7 disclaimer">
        By creating an account, you agree to Hellopeter's
        <a class="link--v2" href="/legal/legal" target="__blank">general terms</a> and
        <a class="link--v2" href="/legal/privacy" target="__blank">privacy policy</a>
      </p>
      <p class="control">
        <button
          id="loginButton"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']"
          :disabled="!canSubmit"
          type="submit"
          @click.prevent="submitRegister">REGISTER
        </button>
      </p>
      <p class="control has-text-centered has-text-weight-bold is-size-7">
        Already have an account?<br/>
        <router-link class="link--v2 has-text-weight-normal" to="/login">Sign in now</router-link>
      </p>
      <!-- reCAPTCHA -->
      <div class="columns">
        <div class="column is-marginless captchaBox">
          <div class="has-text-right-desktop has-text-right-tablet">
            <vue-recaptcha
              ref="recaptcha"
              :sitekey="`${google_recaptcha_site_key}`"
              size="invisible"
              @expired="onCaptchaExpired"
              @verify="onCaptchaVerified">
            </vue-recaptcha>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
/* eslint-disable indent,no-new,no-undef */
import axios from 'axios'
import auth from '@/auth'
import ApiResource from '@/api/ApiResource'
import VuePassword from 'vue-password'
import FlashMessage from '@/components/FlashMessage'
import VueRecaptcha from 'vue-recaptcha'
import {VuePhone} from '@/components'
import {otp_phone_verification} from '@/mixins'

export default {
  name: 'Register',
  metaInfo () {
    return {
      title: 'Register an account - Review Companies Online | Customer Service & Company Ratings | hellopeter.com'
    }
  },
  mixins: [otp_phone_verification],
  components: {
    VuePassword,
    FlashMessage,
    VueRecaptcha,
    VuePhone
  },
  data () {
    return {
      disableStrength: true,
      sending: false,
      form: new ApiResource({
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        password: '',
        password_confirm: '',
        provider: '',
        provider_id: '',
        recaptchaToken: ''
      }),
      otp_form: new ApiResource({
        token: this.token,
        otp: '',
        recaptchaToken: ''
      }),
      error: false,
      socialError: false,
      error_message: '',
      registerSuccessMessage: '',
      showRegisterSuccessMessage: false,
      require_email: false,
      social: false,
      google_recaptcha_site_key: process.env.GOOGLE_RECAPCHA_SITE_KEY,
    }
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Register'
    })
  },
  created () {
    this.error = false
    this.socialError = false
    this.error_message = auth.user.error_message
    auth.redirectSocial = loggedIn => {
      this.socialError = auth.user.socialError
      this.error_message = auth.user.error_message
      auth.user.authenticated = loggedIn
      if (loggedIn) {
        delete window.auth
        this.redirect()
      }
    }
    auth.showError = (message, errorObject = {}) => {
      this.error = true
      this.error_message = message
      if (typeof errorObject.response !== 'undefined' && typeof errorObject.response.data !== 'undefined') {
        // assume validation errors from FB register
        const errors = errorObject.response.data
        this.form.fail(errors)
      }
    }
    auth.showRequireEmail = (requiresEmail) => {
      this.require_email = requiresEmail
      this.social = true
      if (typeof window.auth.prem_user_data !== 'undefined') {
        const tmpData = window.auth.prem_user_data
        this.form.first_name = tmpData.first_name
        this.form.last_name = tmpData.last_name
        this.form.mobile = tmpData.phone
        this.form.email = tmpData.email
        this.form.provider = tmpData.provider
        this.form.provider_id = tmpData.provider_id
      }
    }

    auth.verifyPhone = (shouldRedirect, uuid) => {
      if (shouldRedirect) {
        this.$router.push(`/verify-phone/${uuid}`);
      }
    }
    window.auth = auth

    if (auth.loggedIn()) {
      this.redirect()
    }

    window.prerenderReady = true
  },
  computed: {
    canSubmitOtp () {
      const otp = this.otp_form.otp
      return otp.length > 0 && otp.match(/^(\d\s*){6}$/g) // OTP must be 6 digits
    },
    canSubmit () {
      const email = this.form.email
      if (this.require_email && typeof email !== 'undefined' && email.length > 0) {
        return true
      }
      const firstName = this.form.first_name
      const lastName = this.form.last_name
      const mobile = this.form.mobile
      const password = this.form.password
      const confirm_password = this.form.password_confirm

      if (typeof firstName === 'undefined' || typeof lastName === 'undefined' || typeof mobile === 'undefined' || typeof password === 'undefined') {
        return false
      }

      return firstName.length > 0 &&
        lastName.length > 0 &&
        email.length > 0 &&
        mobile.length > 0 &&
        password.length > 0 &&
        password === confirm_password
    },
    redirectUrl () {
      if (this.$route.query.redirect) {
        return this.$route.query.redirect
      }
      return '/'
    },
    showPasswordNoMatch () {
      const password = this.form.password
      const confirm_password = this.form.password_confirm

      return password.length > 0 && confirm_password.length > 0 && password !== confirm_password
    }
  },
  methods: {
    redirect () {
      this.$router.replace(this.redirectUrl)
      window.prerenderReady = true
    },
    submitRegister () {
      this.form.errors.clear(null)
      this.$refs.recaptcha.execute()
    },
    submitOTP () {
      this.otp_form.errors.clear(null)
      this.$refs.recaptcha_otp.execute()
    },
    /**
     * Reset recaptcha when expired
     *
     * @returns {void}
     */
    onCaptchaExpiredOtp () {
      this.$refs.recaptcha_otp.reset()
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerifiedOtp (recaptchaToken) {
      const self = this
      self.sending = true
      self.$refs.recaptcha_otp.reset()
      self.otp_form.recaptchaToken = recaptchaToken
      self.otp_form.send('/consumer/verify/otp')
        .then(() => {
          self.sending = false
          localStorage.setItem('auth_token', self.otp_form.token)
          localStorage.setItem('profile_id', self.otp_form.profile_id)
          localStorage.setItem('mobile', self.otp_form.mobile)
          localStorage.setItem('displayName', self.otp_form.displayName)
          localStorage.setItem('avatar', self.otp_form.avatar)
          delete window.auth
          this.$router.push('/')
        })
        .catch((errors) => {
          console.log('errors', errors)
          self.sending = false
          if ('errors' in errors) {
            Object.assign(self.otp_form.errors, errors)
          } else {
            console.log('errors from otp verify', errors.error)
            // flash(errors.error, 'is-danger')
          }
        })
    },
    /**
     * Reset recaptcha when expired
     *
     * @returns {void}
     */
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    /**
     * Handle when recaptcha passes
     *
     * @returns {void}
     */
    onCaptchaVerified (recaptchaToken) {
      const self = this
      self.sending = true
      self.$refs.recaptcha.reset()
      self.form.recaptchaToken = recaptchaToken
      self.form.send('/consumer/register')
        .then(() => {
          self.sending = false
          this.$gtm.trackEvent({
            event: 'conversionSuccess',
            type: 'Register'
          })
          if (typeof self.form.message !== 'undefined') {
            // display message for user
            self.showRegisterSuccessMessage = true
            self.registerSuccessMessage = self.form.message
            if (typeof self.form.profile_id !== 'undefined') {
              this.otp_form.token = self.form.profile_id
            }
          } else if (typeof self.form.token !== 'undefined' && typeof self.form.profile_id !== 'undefined') {
            localStorage.setItem('auth_token', self.form.token)
            localStorage.setItem('profile_id', self.form.profile_id)
            localStorage.setItem('mobile', self.form.mobile)
            localStorage.setItem('displayName', self.form.displayName)
            localStorage.setItem('avatar', self.form.avatar)
            delete window.auth
            this.$router.push('/')
          }
        })
        .catch((errors) => {
          self.sending = false

          console.log(errors, JSON.stringify(errors))
          if ('errorKey' in errors && errors.errorKey === 'sms-send-failed') {
            this.$router.push(`/verify-phone/${errors.profile_id}?traceCode=${errors.traceCode}`)
          } else if ('errors' in errors) {
            Object.assign(self.form.errors, errors)
          } else {
            flash(errors.error, 'is-danger')
          }
        })
    },
    socialLogin (provider, alias) {
      let socialAlias = 'loading' + alias
      let windowReference = window.open('about:blank', `${provider}Login`, 'width=585,height=550,toolbar=0,menubar=0,location=0,status=0,scrollbars=1,resizable=1,left=400,top=100')
      this[socialAlias] = true
      axios.get(`/consumer/social-login/${provider}`)
        .then((response) => {
          windowReference.location = response.data.url
          this[socialAlias] = false
        })
        .catch((error) => {
          windowReference.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#registerPage .control {
  margin-top: 10px;
  margin-bottom: 15px;
}

#registerPage #loginButton {
  margin-top: 30px;
}

.disclaimer {
  color: #58595B;
  margin-top: 1rem;
}

.social-email-require {
  background-color: #e8441f;
  color: #ffffff;
  font-size: 0.9rem;
  padding: 10px !important;
  margin-bottom: 20px;
}

.help {
  margin-top: -10px;
}

.register-success-message-box {
  padding: 10px !important;
  background-color: #0fa8e3;
  color: #ffffff;
  font-size: 0.9rem;
}

.captchaBox {
  padding: 6px 0 0;
}

.lh {
  line-height: 1.5rem;
}

/* .country-selector__input { */
/*   border-color: #dbdbdb; */
/*   border-top-left-radius: 20px!important; */
/*   border-bottom-left-radius: 20px!important; */
/* } */
/**/
/* .input-tel__input { */
/*   border-color: #dbdbdb; */
/*   border-top-right-radius: 20px!important; */
/*   border-bottom-right-radius: 20px!important; */
/* } */
</style>



// WEBPACK FOOTER //
// src/pages/auth/Register.vue